import { useEffect, useState } from 'react'
import { getBuyerDistribuicao, type BuyerDistribuicao } from '@/lib/api-shell'

export type BuyerDistribuicaoStatus = 'idle' | 'loading' | 'ready' | 'error'

export function useBuyerDistribuicao(
  enabled: boolean = true,
  scopeKey: string | number | null = null
): {
  distribuicao: BuyerDistribuicao | null
  status: BuyerDistribuicaoStatus
} {
  const [distribuicao, setDistribuicao] = useState<BuyerDistribuicao | null>(null)
  const [status, setStatus] = useState<BuyerDistribuicaoStatus>(enabled ? 'loading' : 'idle')
  const [loadedScopeKey, setLoadedScopeKey] = useState<string | number | null>(null)

  useEffect(() => {
    if (!enabled) {
      setDistribuicao(null)
      setStatus('idle')
      setLoadedScopeKey(null)
      return
    }

    let active = true
    setDistribuicao(null)
    setStatus('loading')
    setLoadedScopeKey(null)

    getBuyerDistribuicao()
      .then((data) => {
        if (!active) return
        setDistribuicao(data)
        setStatus('ready')
        setLoadedScopeKey(scopeKey)
      })
      .catch(() => {
        if (!active) return
        setDistribuicao(null)
        setStatus('error')
        setLoadedScopeKey(scopeKey)
      })

    return () => {
      active = false
    }
  }, [enabled, scopeKey])

  const scopeMatches = loadedScopeKey === scopeKey
  return {
    distribuicao: scopeMatches ? distribuicao : null,
    status: enabled && !scopeMatches ? 'loading' : status,
  }
}
